var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C8.5864 0 3.00037 4.0282 0 10C3.00037 15.9729 8.5864 20 15 20C21.4136 20 26.9996 15.9729 30 10C26.9996 4.0282 21.4136 0 15 0ZM15 16.25C11.5477 16.25 8.74988 13.4522 8.74988 10C8.74988 6.54777 11.5477 3.74995 15 3.74995C18.4523 3.74995 21.2501 6.54777 21.2501 10C21.2501 13.4522 18.4523 16.25 15 16.25Z",
    fill: "#D3B36E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 13.75C17.0711 13.75 18.75 12.071 18.75 10C18.75 7.92896 17.0711 6.25005 15 6.25005C12.9289 6.25005 11.25 7.92896 11.25 10C11.25 12.071 12.9289 13.75 15 13.75Z",
    fill: "#D3B36E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.f3d424a2d87a440de1f60708af1bd07c.svg";
export { ForwardRef as ReactComponent };